import { Controller } from "@hotwired/stimulus";

const storageKey = "performance_metrics_hidden";

export default class extends Controller {
  static targets = ["toggleButton", "metricsSection", "buttonText", "icon"];

  connect() {
    this.restoreState();
  }

  toggle() {
    const isCurrentlyHidden =
      this.metricsSectionTarget.classList.contains("hidden");

    if (isCurrentlyHidden) {
      this.showMetrics();
    } else {
      this.hideMetrics();
    }
  }

  hideMetrics() {
    this.metricsSectionTarget.classList.add("hidden");
    this.buttonTextTarget.textContent = "Show performance metrics";
    this.iconTarget.classList.remove("fa-regular", "fa-eye-slash");
    this.iconTarget.classList.add("fa-regular", "fa-eye");
    this.saveState(true);
  }

  showMetrics() {
    this.metricsSectionTarget.classList.remove("hidden");
    this.buttonTextTarget.textContent = "Hide performance metrics";
    this.iconTarget.classList.remove("fa-regular", "fa-eye");
    this.iconTarget.classList.add("fa-regular", "fa-eye-slash");
    this.saveState(false);
  }

  saveState(isHidden) {
    const stateData = { hidden: isHidden };
    sessionStorage.setItem(storageKey, JSON.stringify(stateData));
  }

  restoreState() {
    const savedState = sessionStorage.getItem(storageKey);

    if (savedState) {
      try {
        const stateData = JSON.parse(savedState);

        if (stateData.hidden) {
          this.hideMetrics();
        } else {
          this.showMetrics();
        }
      } catch (error) {
        sessionStorage.removeItem(storageKey);
      }
    }
  }
}
